module.exports = __webpack_public_path__ + "img/微信图片_20210131164304.c75c2761.png";